import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAvatar,{staticClass:"elevation-1 grey lighten-1",attrs:{"size":"40"}},[_c('span',[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }